<template>
  <div>
    <Header></Header>
    <WorkCenterPlanning
      class="work-center-planning"
      @productSelected="showProduct"
      @hideProduct="hideProduct"
    />
    <RelevantInformation class="relevant-information" />
    <div :style="previewStyle">
      <ProductPreview ref="productPreview"></ProductPreview>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import WorkCenterPlanning from "@/components/production-planning/WorkCenterPlanning.vue";
import RelevantInformation from "@/components/production-planning/RelevantInformationTable.vue";
import ProductPreview from "@/components/user/products/ProductPreview.vue";
export default {
  data() {
    return {
      cursorPosition: null,
      user: this.$session.get("user"),
    };
  },
  created() {
    if (this.user.company_id == 9) {
      this.$session.destroy();
      this.$router.push("/login").catch(() => {});
    }
    document.addEventListener("mousemove", this.onMouseMove, false);
  },
  computed: {
    previewStyle() {
      if (!this.cursorPosition) return;
      return {
        "z-index": 1000,
        position: "fixed",
        top: this.cursorPosition.y + 10 + "px",
        left: this.cursorPosition.x + 10 + "px",
      };
    },
  },
  methods: {
    onMouseMove(e) {
      this.hideProduct();
      this.cursorPosition = {
        x: e.clientX,
        y: e.clientY,
      };
    },

    showProduct(product) {
      this.$refs.productPreview.showProduct(product);
    },

    hideProduct() {
      if (this.$refs.productPreview) {
        this.$refs.productPreview.hideProduct();
      }
    },
  },
  components: {
    Header,
    WorkCenterPlanning,
    RelevantInformation,
    ProductPreview,
  },
};
</script>

<style scoped>
.work-center-planning {
  position: absolute;
  left: 0;
  right: 0;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  height: calc(65%);
  overflow-y: auto;
}
.work-center-planning::-webkit-scrollbar {
  width: 10px;
}

.work-center-planning::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.work-center-planning::-webkit-scrollbar-thumb {
  background: rgba(117, 121, 129, 0.952);
}
.relevant-information {
  position: absolute;
  top: calc(65% + 70px);
  width: 100%;
  height: calc(35% - 70px);
}
</style>